// 9fbef606107a605d69c0edbcd8029e5d
/**
 * These are temporary changes for a dummy login page
 */

import { call, takeLatest, put, select } from 'redux-saga/effects';
import FORGOTPASSWORD_CONSTANTS from '../ForgotPassword.constants';
import {
  getResetPasswordSuccess,
  userNotAvailable,
  getResetPasswordFail,
  forgotPasswordFormSubmitStart,
  forgotPasswordFormSubmitStop,
  setLogonId,
  setIsShowOtpScreen,
  setModuleXContent,
} from './ForgotPassword.actions';
import {
  forgotPassword,
  forgotPasswordMS,
} from '../../../../../services/abstractors/account/ForgotPassword';
import { getModuleX } from '../../../../../services/abstractors/common/moduleXComposite';
import { routerPush } from '../../../../../utils';
import { getIsMuleLogonApiEnable } from '../../../../../reduxStore/selectors/session.selectors';

export function* ForgotPassword(action) {
  try {
    const isMuleEnable = yield select(getIsMuleLogonApiEnable);
    const body = {
      formFlag: 'true',
      isPasswordReset: 'true',
      logonId: action.payload.logonId,
      reLogonURL: 'ChangePassword',
      target: action.payload.target,
      isSfccPlatform: !isMuleEnable,
    };
    yield put(forgotPasswordFormSubmitStart());
    yield put(setLogonId(action.payload.logonId));
    const res = yield call(isMuleEnable ? forgotPassword : forgotPasswordMS, body);
    /* istanbul ignore else */
    if (res) {
      yield put(getResetPasswordSuccess({ state: true }));
      if (action?.payload?.isFromLogin) {
        routerPush(`/change-password?page=reset`, `/change-password?page=reset`);
      }
      yield put(setIsShowOtpScreen(true));
    }
    yield put(forgotPasswordFormSubmitStop());
  } catch (err) {
    let error = {};
    /* istanbul ignore else */
    error = err;
    yield put(forgotPasswordFormSubmitStop());
    if (action?.payload?.isFromLogin) {
      routerPush(`/change-password?page=reset`, `/change-password?page=reset`);
    }
    if (error && error.response && error.response.body) {
      return yield put(userNotAvailable(error.response.body.errors[0]));
    }
    yield put(getResetPasswordFail({ state: true }));
  }
}

const getCidsMap = (referred) => {
  return referred.reduce((result, current) => {
    return {
      ...result,
      [current.contentId]: current.name,
    };
  }, {});
};

export function* fetchModuleX({ referred }) {
  try {
    const cidMap = getCidsMap(referred);
    const cids = Object.keys(cidMap);
    if (cids.length > 0) {
      const result = yield call(getModuleX, referred);
      yield put(setModuleXContent(result));
    }
  } catch (err) {
    yield null;
  }
}

export function* ForgotPasswordSaga() {
  yield takeLatest(FORGOTPASSWORD_CONSTANTS.RESET_PASSWORD, ForgotPassword);
  yield takeLatest(FORGOTPASSWORD_CONSTANTS.GET_MODULEX_CONTENT, fetchModuleX);
}

export default ForgotPasswordSaga;
